import { render, staticRenderFns } from "./certificateAlert.vue?vue&type=template&id=6cc34097&scoped=true"
import script from "./certificateAlert.vue?vue&type=script&lang=js"
export * from "./certificateAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc34097",
  null
  
)

export default component.exports